<template>
  <transition name="fade" mode="out-in">
    <div v-show="displayed" id="assistant-overlay" class="assistant-overlay">
      <CloseButton :white="true" @click.native="hide" />
      <div class="top">
        <div class="left">
          <div v-if="showAnalysis" class="ia-box-wrapper">
            <div class="ia-box-head">
              <img src="/images/ia/analyst.png" alt=""></div>
            <div class="ia-box content-gradient">
              <div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="ia-box-text" v-html="component.iaAnalysisText" />
                <div v-for="(btn, idx) in component.iaAnalysisBtns" :key="idx">
                  <button @click="btn.action(App)">
                    {{ btn.text }}
                  </button><br>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="showSensei" class="ia-box-wrapper">
            <div class="ia-box-head">
              <img src="/images/ia/sensei.png" alt=""></div>
            <div class="ia-box content-gradient">
              <div>
                <BlurUpgradeWrapper
                  :text="$t('sensei.SENSEI')"
                  :hint="$t('sensei.SENSEI_HINT')"
                  :blur="!currentTeam || !!currentTeam.covidVersion"
                >
                  <div>
                    <div class="ia-box-text" v-html="component.iaTeachText" />
                    <div v-for="(btn, idx) in component.iaTeachBtns" :key="idx">
                      <button @click="btn.action()">
                        {{ btn.text }}
                      </button><br>
                    </div>
                  </div>
                </BlurUpgradeWrapper>
                <!-- eslint-disable-next-line vue/no-v-html -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div v-if="showHelp" class="ia-box-wrapper half">
          <div class="ia-box-head">
            <img src="/images/ia/help.png" alt="">
          </div>
          <div class="ia-box content-gradient">
            <div>
              <div v-if="showHelpSteps">
                <div class="ia-box-text">
                  {{ $t("help.NEED_HELP") }}
                </div>
                <button @click="help()">
                  {{ $t("help.HELP") }}
                </button>
              </div>
              <div class="ia-box-wrapper__manuals">
                <div v-if="showHelpSteps" class="sep" />
                <div class="ia-box-text">{{ $t("help.NEED_USER_MANUAL") }}</div>
                <div v-for="manual in userManuals" :key="manual.id" class="ia-box-wrapper__manuals__manual">
                  <button @click="currentUserManual = manual">
                    {{ manual.name }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal :value="currentUserManual !== null" xlarge @input="currentUserManual = null">
        <embed
          v-if="currentUserManual !== null"
          class="assistant-overlay__manual"
          :src="currentUserManual.file"
          width="0px"
          height="0px"
          type="application/pdf"
        >
      </Modal>
    </div>
  </transition>
</template>

<script>
/**
 * Intelligent assistant dark overlay
 */
import $ from 'jquery';
import Vue from 'vue';
// Components
import BlurUpgradeWrapper from '@/components/blur-upgrade-wrapper.vue';
import CloseButton from '@/components/close-button.vue';
import Modal from '@/components/modal.vue';
// Utils
import SPage from '@/utils/classes/SPage';


export default {

  name: 'AssistantOverlay',

  components: {
    BlurUpgradeWrapper,
    CloseButton,
    Modal,
  },

  props: {
    component: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      closeCallback: null,
      displayed: false,
      currentUserManual: null,
      // TODO: Translate teh manuals in english
      allManuals: [
        {
          id: 0,
          name: this.$t('help.USER_MANUAL_BASICS'),
          file: 'https://drive.google.com/file/d/1AvTdlH8lRvrnvybrnUYjs2HZs4UDYiPx/preview',
          categories: ['main'],
        },
        {
          id: 1,
          name: this.$t('help.USER_MANUAL_SETTINGS'),
          file: 'https://drive.google.com/file/d/1Kwa65ViAXk-6rw2BOXbk_jzAJi1GlguK/preview',
          categories: ['settings'],
        },
        {
          id: 2,
          name: this.$t('help.USER_MANUAL_CONFIG'),
          file: 'https://drive.google.com/file/d/1zCdjbb2zAfpxWrApNBlBLgfhF3KFd0Ac/preview',
          categories: ['config'],
        },
        {
          id: 3,
          name: this.$t('help.USER_MANUAL_GW'),
          file: 'https://drive.google.com/file/d/1AMlkWjr6-4VOlzBfN495JhZWZ-H9WNUd/preview',
          categories: ['gembaWalk'],
        },
        {
          id: 4,
          name: this.$t('help.USER_MANUAL_GW_SETTINGS'),
          file: 'https://drive.google.com/file/d/1WEL5zitjNkkKaZtE1I4jn7E78CJTEvCr/preview',
          categories: ['gembaWalk'],
        },
        {
          id: 5,
          name: this.$t('help.USER_MANUAL_MGT_PAGES'),
          file: 'https://drive.google.com/file/d/1YJN_ruHbn6RhOSmSVUkFszXSNTl5RFB_/preview',
          categories: ['management'],
        },
      ],
    };
  },

  computed: {
    showAnalysis() {
      if (!this.component) {
        return false;
      }
      const { iaAnalysisText, iaAnalysisBtns } = this.component;
      return (iaAnalysisText && iaAnalysisText !== '') || (iaAnalysisBtns && iaAnalysisBtns.length);
    },
    showSensei() {
      if (!this.component) {
        return false;
      }
      const { iaTeachText, iaTeachBtns } = this.component;

      return (iaTeachText && iaTeachText !== '') || (iaTeachBtns && iaTeachBtns.length);
    },
    /** Boolean: Whether a step-y-step guide is available for this page */
    showHelpSteps() {
      return this.component
        && (
          typeof this.component.createHelpSteps === 'function'
          || typeof this.component.createHelpStepsGroups === 'function'
        );
    },
    /** Boolean: Whether thre's a step-y-step guide or a user manual for this page */
    showHelp() {
      return this.showHelpSteps || this.userManuals.length;
    },
    /** Number: ID of the current page if found in SPage */
    pageObjectFromRoute() {
      // Found a page match using route path
      if (SPage.fromLink[this.$route.path] && SPage.fromLink[this.$route.path].id) {
        return SPage.fromLink[this.$route.path];
      }
      // Find a page match using original route path
      if (this.$route.matched.length && this.$route.matched[0].path) {
        const path = this.$route.matched[0].path;
        if (SPage.fromLink[path] && SPage.fromLink[path].id) {
          return SPage.fromLink[path];
        }
      }
      return null;
    },
    /** Array: Available user manuals according to the current route */
    userManuals() {
      if (!this.pageObjectFromRoute || !this.pageObjectFromRoute.category) {
        return this.allManuals.filter(m => m.categories.includes('main'));
      }
      return this.allManuals.filter(m => m.categories.includes(this.pageObjectFromRoute.category));
    },
  },

  methods: {
    show(component, closeCallback) {
      // Check if IA is setup for this component
      if (this.showAnalysis || this.showSensei || this.showHelp) {
        // Show
        this.closeCallback = closeCallback;
        this.displayed = true;
        this.setupAnchoredBtns();
        $(document).on(this.escKeyupEventName, () => { this.hide(); });
        return true;
      }
      return false;
    },
    /** Setup btns that should appear after some element */
    setupAnchoredBtns() {
      const btns = this.component.iaAnchoredBtns || [];
      Vue.nextTick(() => {
        if (btns && btns.length) {
          for (let i = 0, len = btns.length; i < len; i++) {
            const finalI = i;
            if (btns[i].anchor) {
              $(`#${btns[i].anchor}`).off('click');
              $(`#${btns[i].anchor}`).on('click', () => {
                btns[finalI].action();
              });
            }
          }
        }
      });
    },
    hide() {
      this.displayed = false;
      this.currentUserManual = null;
      if (this.closeCallback) {
        this.closeCallback();
      }
    },
    /** Start help tutorial */
    help(component) {
      this.hide();
      this.$emit('showHelp', component || this.component);
    },
  },

};
</script>

<style lang="scss">
.ia-box-wrapper {
  .blur-upgrade-wrapper {
    .hint {
      padding: 0px 5%;
    }
  }
  &__manuals {
    .sep {
      margin: 1em 20%;
      width: 60%;
    }
    &__manual:last-child {
      margin-bottom: 2em;
    }
  }
}

.assistant-overlay {
  &__manual {
    width: 100%;
    height: 100%;
  }
}
</style>
